import Styles from "./styles.module.scss";
import Package from "../../../package.json";
import React, { useContext } from "react";
import T from "i18n-react";

import "react-flags-select/css/react-flags-select.css";
import { connect } from "react-redux";
import SelectLanguage from "../Widgets/SelectLanguage";
import { _ChangeRedirect, _ChangeLng } from "../../redux/actions";
import { Auth0Context } from "../../yoello-lib/modules/auth/Auth0";
import IConsumerUser from "../../yoello-lib/modules/auth/IConsumerUser";
import { withRouter } from "react-router";
import { LOGIN } from "../../constants/URL.const";
import withDrawerWrapper from "../Drawer/withDrawerWrapper";
import Support from "../Widgets/Support";
import { ReactComponent as YoelloLogoSVG } from "../../imges/yoelloLogo-w.svg";
import Button from "../Widgets/Button";
import { dispatchLanguage } from "../../redux/actions";
import { APP_LANGUAGES } from "../../constants";
import { ReactComponent as OrderHistorySVG } from "../../imges/Bag.svg";
import LanguagePicker from "../../Components/Widgets/LanguagePicker";
import { ReactComponent as SupportSVG } from "../../imges/Heart.svg";
import { ReactComponent as BlogSVG } from "../../imges/Document.svg";
import { ReactComponent as BusinessSVG } from "../../imges/Work.svg";
import { ReactComponent as LegalsSVG } from "../../imges/Password.svg";
import { ReactComponent as LogoutSVG } from "../../imges/Logout.svg";
import { ReactComponent as PlaceholderSVG } from "../../imges/placeholder.svg";

import { ISideMenuProps } from "./types.d";

const ListItems = [
  {
    name: "Orderhistory",
    icon: <OrderHistorySVG width="1rem" height="1.125rem" />,
  },
  // {
  //   name: "Website",
  //   icon: <WebsiteSVG width="1.375rem" height="1.0625rem" />,
  //   url:
  //     "www.yoello.com?utm_source=Consumer%20app%20menu%20link%20to%20website&utm_medium=Consumer%20app%20menu%20link%20to%20website&utm_campaign=Consumer%20app%20menu%20link%20to%20website&utm_content=Testing%20traffic%20from%20consumer%20app%20menu%20to%20website",
  // },
  {
    name: "Support",
    icon: <SupportSVG width="	1.1875rem" height="1.125rem" />,
    isSupport: true,
    // url: "https://www.yoello.com/support",
  },
  {
    name: "Blog",
    icon: <BlogSVG width="1rem" height="1.125rem" />,
    url: "https://www.yoello.com/blog",
  },
  {
    name: "Referbusiness",
    icon: <BusinessSVG width="1.0625rem" height="1.0625rem" />,
    url: "https://www.yoello.com/recommend-business",
  },
  {
    name: "Legals",
    icon: <LegalsSVG width="1.125rem" height="1.125rem" />,
    url: "https://www.yoello.com/terms-conditions",
  },
];

const LoginListItems = [
  {
    name: "Support",
    icon: <SupportSVG width="	1.1875rem" height="1.125rem" />,
    isSupport: true,
    // url: "https://www.yoello.com/support",
  },
  // {
  //   name: "Website",
  //   icon: <WebsiteSVG width="1.375rem" height="1.0625rem" />,
  //   url:
  //     "www.yoello.com?utm_source=Consumer%20app%20menu%20link%20to%20website&utm_medium=Consumer%20app%20menu%20link%20to%20website&utm_campaign=Consumer%20app%20menu%20link%20to%20website&utm_content=Testing%20traffic%20from%20consumer%20app%20menu%20to%20website",
  // },
  {
    name: "Blog",
    icon: <BlogSVG width="1rem" height="1.125rem" />,
    url: "https://www.yoello.com/blog",
  },
  {
    name: "Referbusiness",
    icon: <BusinessSVG width="1rem" height="1.125rem" />,
    url: "https://www.yoello.com/recommend-business",
  },
  {
    name: "Legals",
    icon: <LegalsSVG width="1rem" height="1.125rem" />,
    url: "https://www.yoello.com/terms-conditions",
  },
];
const SideMenu = (props: ISideMenuProps) => {
  const context = useContext(Auth0Context);
  const onSelectedLanguageChange = (key: string) => {
    props.dispatchLanguage(key);
    props.closeDrawer();
  };
  const openLanguageDrawer = () => {
    props.openDrawer(
      //@ts-ignore
      SelectLanguage,
      {
        languages: APP_LANGUAGES,
        onCloseDrawer: props.closeDrawer,
        onSelectedLanguageChange: onSelectedLanguageChange,
      },
      "bottom",
      "SelectLanguageDrawer"
    );
  };
  const onClickItemWithoutUrl = () => {
    props.closeDrawer();
    props.openSettingsPage(1);
  };
  const onClickLogout = () => {
    context.logout();
  };
  const openSupportDrawer = () => {
    props.openDrawer(
      //@ts-ignore
      Support,
      {
        onCloseDrawer: props.closeDrawer,
      },
      "bottom",
      "SupportDrawer"
    );
  };
  const renderUserFirstName = () => {
    const user = context.user as IConsumerUser;
    if (user) {
      return user.first_name;
    } else return "User";
  };
  const renderContent = () => {
    let temp;
    if (context.user) {
      temp = (
        <div>
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "stretch",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: "1.6rem",
              }}
            >
              <div>
                <T.p
                  className={Styles.UserName}
                  text={{ key: `SideMenu.Hello` }}
                />
                <p className={Styles.UserName}>
                  <strong>{renderUserFirstName()}</strong>
                </p>
              </div>
              <div
                className="Flex AlignCenter mt-auto"
                data-component-name={"SignOutButton"}
              >
                <LogoutSVG width="18px" height="18px" />
                <T.p
                  onClick={onClickLogout}
                  className={Styles.SignOut}
                  text={{ key: `SideMenu.SignOut` }}
                />
              </div>
            </div>

            {ListItems.map((item, i) => {
              if (item.url) {
                return (
                  <a
                    key={i}
                    rel="noopener noreferrer"
                    href={item.url}
                    target="_blank"
                  >
                    {" "}
                    <div className={Styles.MenuItemDiv}>
                      <div className={Styles.SVGsDiv}>{item.icon}</div>
                      <T.p
                        className={Styles.MenuItemName}
                        text={{ key: `SideMenu.${item.name}` }}
                      />
                    </div>
                  </a>
                );
              } else {
                return (
                  <div
                    key={i}
                    data-component-name={item.name}
                    onClick={
                      item.isSupport ? openSupportDrawer : onClickItemWithoutUrl
                    }
                    className={Styles.MenuItemDiv}
                  >
                    <div className={Styles.SVGsDiv}>{item.icon}</div>
                    <T.p
                      className={Styles.MenuItemName}
                      text={{ key: `SideMenu.${item.name}` }}
                    />
                  </div>
                );
              }
            })}
          </div>
        </div>
      );
    } else {
      temp = (
        <div>
          <div>
            <T.p
              className={Styles.ScanTitleText}
              text={{ key: `SideMenu.ScanOrderPay` }}
            />
            <T.p
              className={Styles.SignInText}
              text={{ key: `SideMenu.SignInText` }}
            />
          </div>
          <div>
            <Button
              className={Styles.SignInButton}
              dataComponentName="SignInButton"
              isYoelloBtn
              onClick={() => {
                props.history.push(LOGIN);
              }}
              title="SignIn"
            />
          </div>
          <div>
            {/* <p className="UserName pl-1">You are not Logged IN</p> */}

            {LoginListItems.map((item, i) => {
              if (item.url) {
                // "Flex AlignCenter MenuItemDiv"
                return (
                  <a
                    key={i}
                    rel="noopener noreferrer"
                    href={item.url}
                    target="_blank"
                  >
                    {" "}
                    <div className={Styles.MenuItemDiv}>
                      <div className={Styles.SVGsDiv}>{item.icon}</div>
                      <T.p
                        className={Styles.MenuItemName}
                        text={{ key: `SideMenu.${item.name}` }}
                      />
                    </div>
                  </a>
                );
              } else {
                return (
                  <div
                    key={i}
                    onClick={
                      item.isSupport
                        ? openSupportDrawer
                        : () => {
                            props.closeDrawer();
                            props.openSettingsPage(1);
                          }
                    }
                    className={Styles.MenuItemDiv}
                  >
                    <div className={Styles.SVGsDiv}>{item.icon}</div>
                    <T.p
                      className={Styles.MenuItemName}
                      text={{ key: `SideMenu.${item.name}` }}
                    />
                  </div>
                );
              }
            })}
          </div>
        </div>
      );
    }
    return temp;
  };
  const renderHeader = () => {
    if (
      window.location.pathname.split("/")[1] === "g" &&
      props.Group &&
      !window.location.pathname.split("/")[3]
    ) {
      return (
        <div className={Styles.VenueHeader}>
          <p>{props.Group.group_name_public}</p>
        </div>
      );
    } else {
      return (
        <div className={Styles.VenueHeader}>
          {props.Venue.url_logo ? (
            <img src={props.Venue.url_logo} alt="" />
          ) : (
            <PlaceholderSVG />
          )}
          <p>{props.Venue.venue_name}</p>
        </div>
      );
    }
  };
  const setTranslation = () => {
    //Temp solution, App.tsx is setting translation dict after SideMenu rerenders
    var dictionary = require(`../../LngLocales/${props.localization.language}.json`);
    T.setTexts(dictionary);
  };
  setTranslation();

  return (
    <div
      data-component-name="SideMenuContainer"
      className={Styles.SideMenu}
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <div className={Styles.Header}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {renderHeader()}
          <Button
            onClick={props.closeSideDrawer}
            dataComponentName="ExitButton"
            iconClassName={"consumer-close"}
            style={{
              color: "#FFFFFF",
              fontSize: "1.75rem",
              background: "rgba(255, 255, 255, 0.15)",
              borderRadius: "0.75rem",
              top: "1.875rem",
              right: "1.875rem",
            }}
            isHeaderBtn
          />
        </div>
      </div>
      <div className={Styles.Content}>{renderContent()}</div>
      <div className={Styles.PoweredBy}>
        <div className={Styles.BorderLine} />
        <div className={Styles.LanguageWrapper}>
          <LanguagePicker openDrawer={openLanguageDrawer} showFull={true} />
        </div>
        <p>
          {T.translate("SideMenu.PoweredBy")}
          <YoelloLogoSVG className={Styles.YoelloLogo} />
        </p>
        <span className={Styles.AppVersion}>
          {T.translate("SideMenu.Version")} {Package.version}
        </span>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, {
  _ChangeRedirect,
  _ChangeLng,
  dispatchLanguage,
})(withRouter(withDrawerWrapper(SideMenu)));
